import React, { Component, Suspense} from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import CustomNavbar from "./Navbar.js"
import Footer from "./Footer.js"

import routes from '../routes';

import ReactGA from 'react-ga';

const trackingId = "UA-69780472-2"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);


class DefaultLayout extends Component {

	constructor(props) {
      super(props);

			this.state = {
				letItRide : false
			}
      this.onClick = this.onClick.bind(this);

  }

	loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

  onClick(e) {
		console.log("onClick", e)
    if (e.target.id === "letItRide"){
      this.setState({ letItRide: !this.state.letItRide})
    } else {
      this.setState({ [e.target.id] : e.target.value})
    }
//      ReactGA.event({
//  	    category: e.target.id,
//  	    action: e.target.value,
//  			label: e.target,
//  	  });
    }

	render () {

		ReactGA.pageview(this.props.location.pathname)
		console.log("DefaultLayout.state.letItRide", this.state.letItRide)
		return (
		<div className="app-body">
			<CustomNavbar onClick={this.onClick} letItRide={this.state.letItRide}/>
			<main className="main">
				<Suspense fallback={this.loading()}>
					<Switch>
	          {routes.map((route, idx) => {
	            return route.component ? (
	              <Route
	                key={idx}
	                path={route.path}
	                exact={route.exact}
	                name={route.name}
	                render={props => (
	                  <route.component {...props}
	                  letItRide={this.state.letItRide}
	                  onClick={this.onClick}/>
	                )} />
	            ) : (null);
	          })}
	          <Redirect from="/" to="/home" />
	        </Switch>
	      </Suspense>
			</main>
			<Footer />
		</div>
		)
	}
}

export default DefaultLayout;